import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE_NO_CREDENTIALS } from '../../utils/service-http';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url } from '../../constants';
import ProductInformationCache from '../../persistence/description-cache';
import { appConfiguration } from '../../utils/app-starter';

const DEFAULT_STATE_ACCESSORIES = {
  software: {
    references: [],
    isLoading: false
  },
  accessories: {
    isLoading: false
  },
}

const getSoftwaresStarted = createAction('GET_SOFTWARES_STARTED');
const getSoftwaresSuccess = createAction('GET_SOFTWARES_SUCCESS');
const getSoftwaresFailed = createAction('GET_SOFTWARES_FAILED');

const getAccessoriesStarted = createAction('GET_ACCESSORIES_STARTED');
const getAccessoriesSuccess = createAction('GET_ACCESSORIES_SUCCESS');
const getAccessoriesFailed = createAction('GET_ACCESSORIES_FAILED');

export const accessoriesReducer = createReducer(function (on, off) {
  on(getSoftwaresStarted, (state, payload) => {
    return {
      ...state,
      software: {
        references: [],
        isLoading: true
      }
    };
  });
  on(getSoftwaresSuccess, (state, payload) => {
    return {
      ...state,
      software: {
        references: payload,
        isLoading: false
      }
    };
  });
  on(getSoftwaresFailed, (state, payload) => {
    return {
      ...state,
      software: {
        references: [],
        isLoading: false
      }
    };
  });
  on(getAccessoriesStarted, (state, payload) => {
    return {
      ...state,
      accessories: {
        isLoading: true
      }
    };
  });
  on(getAccessoriesSuccess, (state, payload) => {
    return {
      ...state,
      accessories: {
        isLoading: false
      }
    };
  });
  on(getAccessoriesFailed, (state, payload) => {
    return {
      ...state,
      accessories: {
        isLoading: false
      }
    };
  });

}, DEFAULT_STATE_ACCESSORIES);

const accessoriesCache = {};


function buildRelatedProductsURL(headModuleID) {

  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return `${api_base_url}/compatible-accessories/${headModuleID}?locale=${getAppLocale()}${mainOverrideString}`;
}

export function getSoftwares(headModuleID) {
  return async dispatch => {
    dispatch(getSoftwaresStarted());
    API_INSTANCE_NO_CREDENTIALS.get(buildRelatedProductsURL(headModuleID))
      .then((result) => {
        const softwareResults = result.data?.payload?.softwares || [];
        ProductInformationCache.loadReferencesDescriptions(softwareResults.map(a => a.id));
        dispatch(getSoftwaresSuccess(softwareResults));
      })
      .catch((error) => {
        dispatch(getSoftwaresFailed([]));
        throw error;
      })
  };
}

export function getAccessories(moduleID) {
  return async dispatch => {

    if (accessoriesCache[moduleID]) {
      return accessoriesCache[moduleID];
    }

    dispatch(getAccessoriesStarted());

    return API_INSTANCE_NO_CREDENTIALS.get(buildRelatedProductsURL(moduleID))
      .then((result) => {
        const accessoriesResult = result.data?.payload?.accessories || [];
        const auxiliariesResult = result.data?.payload?.auxiliaries || [];
        const sensorsResult = result.data?.payload?.functions || [];
        const sparePartsResult = result.data?.payload?.spareParts || [];
        const optionsResult = result.data?.payload?.options || [];
        const warrantiesResult = result.data?.payload?.warranties || [];
        ProductInformationCache.loadReferencesDescriptions([...accessoriesResult, ...auxiliariesResult, ...sensorsResult, ...sparePartsResult, ...optionsResult, ...warrantiesResult]
          .flatMap(a => {
            return [a.id, ...(a.subAccessories || []).map((s) => s.id)];
          }));
        dispatch(getAccessoriesSuccess());
        const ret = {
          accessories: {
            accessories: accessoriesResult,
            auxiliaries: auxiliariesResult,
            sensors: sensorsResult,
            options: optionsResult
          },
          services: {
            spareParts: sparePartsResult,
            warranties: warrantiesResult
          }
        };
        accessoriesCache[moduleID] = ret;
        return ret;
      })
      .catch((error) => {
        dispatch(getAccessoriesFailed([]));
        throw error;
      })
  };
}
